module.exports = __webpack_public_path__ + "img/Chambre-froide-portative-Gricd-fridg-DR-1024x576.11235e65.jpg";